import CategoryChip from "../CategoryChip/CategoryChip";
import MindPageLink from "../MindPageLink/MindPageLink";
import DefaultPostSVG from "../SVGs/DefaultPostSVG";
import styles from "./HorizontalPostLink.module.css";

function HorizontalPostLink({ post, placeholder = false, allow }) {
    function getFormattedDateFromPost(post) {
        const date = new Date(post.date);
        const options = {
            month: "long",
            day: "numeric",
            year: "numeric",
        };
        return `${date.toLocaleDateString("en-US", options)}`;
    }

    function PlaceholderLink() {
        return (
            <div className={styles.container}>
                <div className={[styles.thumbnail, "shimmer"].join(" ")}></div>
                <div className={styles.text}>
                    <h3
                        className={[
                            styles.long_placeholder_text,
                            "shimmer",
                        ].join(" ")}
                    >
                        {/* &nbsp; */}
                    </h3>
                    <div
                        className={[
                            styles.short_placeholder_text,
                            "shimmer",
                        ].join(" ")}
                    ></div>
                    <div
                        className={[
                            styles.short_placeholder_text,
                            "shimmer",
                        ].join(" ")}
                    ></div>
                </div>
            </div>
        );
    }

    function LinkWrapper({ children, className }) {
        return (
            <MindPageLink
                href={post?.external_post_url ?? `/mind/news/${post?.id}/`}
                className={[styles.link_wrapper, className].join(" ")}
                target={post?.external_post_url ? "_blank" : ""}
            >
                {children}
            </MindPageLink>
        );
    }

    function PostLink() {
        return (
            <div className={styles.container}>
                <LinkWrapper>
                    {post?.featured_image_url ? (
                        <img
                            src={post?.featured_image_url}
                            className={styles.thumbnail}
                            alt=""
                        />
                    ) : (
                        <div
                            className={[
                                styles.default_post_icon_container,
                                "category",
                            ].join(" ")}
                        >
                            <DefaultPostSVG width={40} height={40} />
                        </div>
                    )}
                </LinkWrapper>
                <div className={styles.text}>
                    <div className={styles.categories_container}>
                        {post?.categories.map(({ name, slug }) => (
                            <CategoryChip key={name} name={name} slug={slug} />
                        ))}
                    </div>
                    <LinkWrapper>
                        <h3 className={styles.title}>
                            {post?.title?.rendered ?? post?.title}
                        </h3>
                    </LinkWrapper>
                    <div className={styles.date}>
                        {getFormattedDateFromPost(post)}
                    </div>
                </div>
            </div>
        );
    }

    return placeholder ? <PlaceholderLink /> : <PostLink />;
    // return <PlaceholderLink />;
}

export default HorizontalPostLink;
